import styled from 'styled-components';

const TemplateContainer = styled.div`
  width: 100%;
`;

export default TemplateContainer;
